<template>
	<HeaderBlock :title="walkthroughTitle" :logicalBack="true" @logicalBack="handleBack()" />
	
	<div class="story-page-content">
		<MGWalkthrough
			v-if="walkthroughData"
			ref="walkthrough"
			:walkthroughData="walkthroughData"
			variant="story"
			:imageHeight="'350'"
			:height="determineCarouselHeight()"
			@slide-title-changed="handleTitleLoaded"
			@slide-index-changed="handleSlideIndexChanged"
			@close-drawer="$router.back()"
			@action-clicked="handleActionClicked"
		/>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import MGWalkthrough from './elements/MGWalkthrough.vue';
import HeaderBlock from './elements/HeaderBlock.vue';

export default {
	name: 'StoryPage',
	components: {
		MGWalkthrough, HeaderBlock
	},
	mixins: [Services],
	data() {
		return {
			walkthroughTitle: '',
			walkthroughData: null,
			currentSlideIndex: 0
		}
	},
	mounted() {
		// Load walkthrough data based on route params or query
		this.loadWalkthroughData();
	},
	methods: {
		loadWalkthroughData() {
			// Get walkthrough ID from route params
			const walkthroughId = this.$route.params.id || this.$route.query.id;
			if (walkthroughId) {
				this._getWalkthrough(walkthroughId, (result) => {
					this.walkthroughData = result;
				});
			}
		},
        handleBack() {
            if (this.currentSlideIndex === 0) {
                this.$router.back();
            } else {
                this.$refs.walkthrough.goToPreviousSlide();
            }
        },
		handleTitleLoaded(title) {
			this.walkthroughTitle = title;
		},
		handleSlideIndexChanged(index) {
			this.currentSlideIndex = index;
		},
		determineCarouselHeight() {
			// Set the height of the carousel so that the slides size correctly and the content below doesn't jump around
			if (window.innerHeight < 700) {
				return '240px';
			} else {
				return '370px';
			}
		},
		handleActionClicked(actionUri) {
			if (actionUri && actionUri.includes('*truelayer*')) {
				this.handleLinkAccount();
				return;
			}
			if (actionUri) {
				this.$router.push(actionUri);
			}
		},
		handleLinkAccount() {
			document.body.classList.remove('hide-nav-bar');
			if (!this.customer) {
				this._getCustomer(() => {
					var navTo = this._getOpenBankingLinkUrl(this.customer.id);
					window.open(navTo, '_blank');
				});
			} else {
				var navTo = this._getOpenBankingLinkUrl(this.customer.id);
				window.open(navTo, '_blank');
			}
		}
	}
};
</script>

<style scoped>
.story-page-content {
	padding: 16px 0;
	margin-bottom: 20px;
	margin-left: -10px;
	margin-right: -10px;
}
</style>
